module.exports = __webpack_public_path__ + "img/newback.0e7a9e2d.png";